import { Typography } from '@mui/material';
import { MdDownloading } from 'react-icons/md';
import { PiFileDashedFill } from 'react-icons/pi';
import IntlMessages from 'util/IntlMessages';

const GeneratingFile = () => {
  return (
    <li className="download-item">
      <div className="download-item-content">
        <PiFileDashedFill size={24} />
        <Typography fontSize={16}>
          <IntlMessages id="pages.downloader.items.generating" />
        </Typography>
      </div>

      <div className="download-item-status">
        <MdDownloading color="#D7D6DA" size={18} />
      </div>
    </li>
  );
};

export default GeneratingFile;
